export const NOTIFICATIONS_DEFAULT = {
  data: [],
  show: false,
}

export const CARD_CHARACTER_TOP = 120
